import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TaxctcService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) { 
    super();
    this.httpClient = new HttpClient(handler);

  }
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

   // Create userCTC
   createuserCtcs(user: Object): Observable<Object> {
    console.log("In createSoftwares method, userCtcs: ", user);
    return this.http.post(`${environment.apiUrl}/userCtcs`, user).pipe(catchError(this.handleError));
  }

   // Get userCTC by Id Get
   getuserCtcs(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/userCtcs/${id}`).pipe(catchError(this.handleError));
  }

   //Delete userCtcs by Id Delete
   deleteuserCtcs(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/userCtcs/${id}`).pipe(catchError(this.handleError));
  }

   //Update userCtcs by Id Put
   updateuserCtcs(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/userCtcs/${id}`, user).pipe(catchError(this.handleError));
  }

  public getuserCtcsById(Id: number) {
    return this.http.get<any>(`${environment.apiUrl}/userCtcs/${Id}`).pipe(catchError(this.handleError));
  }

  //Get All userCtcs by Id Get
  getAlluserCtcs(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/userCtcs`).pipe(catchError(this.handleError));
  }

  //Get All userCtcs by Id Get
  getUserCtcsForArrears(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/userCtcs?type=arrears`).pipe(catchError(this.handleError));
  }

  //Get All userCtcs by Id Get
  getUserCtcsForBonus(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/userCtcs?type=bonus`).pipe(catchError(this.handleError));
  }

  //Get All userCtcs by Id Get
  getUserCtcsForInterns(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/userCtcs?type=stipend`).pipe(catchError(this.handleError));
  }

  public duplicateUserCtcs(data) : Observable<Object>{
    return this.http.put(`${environment.apiUrl}/duplicateUserCtcs?action=duplicate`, data).pipe(catchError(this.handleError));
  }
}
